import { request } from "@/utils/request";

export async function getZones() {
  return request<any>(`/api/shopify-admin/zones`, {
    method: "GET",
  });
}

export async function getCountries() {
  return request<any>(`/api/shopify-admin/countries`, {
    method: "GET",
  });
}

export async function createZone(data: any) {
  return request<any>(`/api/shopify-admin/zones`, {
    method: "POST",
    data,
  });
}

export async function updateZone(data: any) {
  return request<any>(`/api/shopify-admin/zones/${data.zone.id}`, {
    method: "PUT",
    data,
  });
}

export async function deleteZone(id: number) {
  return request<any>(`/api/shopify-admin/zones/${id}`, {
    method: "DELETE",
  });
}
